import { MATCH_CANDIDATES_STATUS } from '../../consts/enums';

type findStatisticItemCountResponse = {
  status: MATCH_CANDIDATES_STATUS;
  count: number;
}

export const calculatePercentage = (partialValue: number, total: number): number => {
  if (total === 0) {
    return 0;
  }

  return (100 * partialValue) / total;
};

export const findStatisticItemCount = (
  data: findStatisticItemCountResponse[],
  status: MATCH_CANDIDATES_STATUS | 'TOTAL',
): findStatisticItemCountResponse | undefined  => {
  return data.find((statisticItem) => statisticItem.status === status);
};
